import { Box, Menu, type MenuProps } from '@mantine/core'
import { IconCopy, IconDotsVertical, IconTrash } from '@tabler/icons-react'
import { forwardRef, useState } from 'react'

interface EntryMenuButtonProps extends Omit<MenuProps, 'children'> {
  onDuplicate?: () => void
  onDelete?: () => void
  canDelete?: boolean
  canDuplicate?: boolean
}

export const EntryMenuButton = forwardRef<HTMLButtonElement, EntryMenuButtonProps>(
  ({ onDuplicate, onDelete, canDelete = true, canDuplicate = true, ...props }, ref) => {
    const [menuOpened, setMenuOpened] = useState(false)

    return (
      <Menu opened={menuOpened} onChange={setMenuOpened} {...props}>
        <Menu.Target>
          <Box
            component="button"
            type="button"
            ref={ref}
            aria-label="More actions"
            aria-haspopup="menu"
            aria-expanded={menuOpened}
            style={{
              cursor: 'pointer',
              opacity: 0.5,
              transition: 'all 200ms ease',
              borderRadius: 4,
              padding: '4px 6px',
              display: 'flex',
              alignItems: 'center',
              background: 'transparent',
              border: 'none',
            }}
            onClick={() => setMenuOpened(!menuOpened)}>
            <IconDotsVertical size={18} aria-hidden="true" />
          </Box>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<IconCopy size={14} />} onClick={onDuplicate} disabled={!canDuplicate}>
            Duplicate
          </Menu.Item>
          <Menu.Item leftSection={<IconTrash size={14} />} color="red" onClick={onDelete} disabled={!canDelete}>
            Delete
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    )
  },
)

EntryMenuButton.displayName = 'EntryMenuButton'
